export enum ACCOUNT_STATUS {
  VIVO_RECHARGES = 'VIVO_RECHARGES',
  PENDING_INFORMATION = 'PENDING_INFORMATION',
  PENDING_PROVIDER = 'PENDING_PROVIDER',
  RECHARGES_PENDING_PROVIDER = 'RECHARGES_PENDING_PROVIDER',
  PENDING_UPLOAD = 'PENDING_UPLOAD',
  RECHARGES_PENDING_UPLOAD = 'RECHARGES_PENDING_UPLOAD',
  PENDING_ONBOARDING = 'PENDING_ONBOARDING',
  ERROR_PROVIDER = 'ERROR_PROVIDER',
  ACTIVE_PROVIDER = 'ACTIVE_PROVIDER',
  INACTIVE_PROVIDER = 'INACTIVE_PROVIDER',
  WAITING_DOCUMENT = 'WAITING_DOCUMENT',
  WAITING_ANALYSIS = 'WAITING_ANALYSIS',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  BLOCKED = 'BLOCKED',
  BLOCKED_PENDING_PROVIDER = 'BLOCKED_PENDING_PROVIDER',
  REPROVED = 'REPROVED',
  INTERNAL = 'INTERNAL',
  BLOCKED_FINANCIAL = 'BLOCKED_FINANCIAL',
}
